import { render, staticRenderFns } from "./ParticipantModal.vue?vue&type=template&id=131034f6&scoped=true&"
import script from "./ParticipantModal.vue?vue&type=script&lang=js&"
export * from "./ParticipantModal.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantModal.vue?vue&type=style&index=0&id=131034f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131034f6",
  null
  
)

export default component.exports